"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LoadingBar", {
    enumerable: true,
    get: function() {
        return LoadingBar;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
var _reactLottie = /*#__PURE__*/ _interopRequireDefault(require("react-lottie"));
var _lottieColorify = require("lottie-colorify");
var _loadingBarAnimationGreen = /*#__PURE__*/ _interopRequireDefault(require("./animations/loadingBarAnimationGreen"));
var _loadingBarAnimationWhite = /*#__PURE__*/ _interopRequireDefault(require("./animations/loadingBarAnimationWhite"));
var _loadingLogoAnimationGreen = /*#__PURE__*/ _interopRequireDefault(require("./animations/loadingLogoAnimationGreen"));
var _loadingLogoAnimationWhite = /*#__PURE__*/ _interopRequireDefault(require("./animations/loadingLogoAnimationWhite"));
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var DEFAULT_OPTIONS = {
    loop: true,
    autoplay: true
};
var ColorExp = /^#(?:[0-9a-fA-F]{3}){1,2}$/;
var safeReplaceColor = function(color, animation) {
    try {
        return (0, _lottieColorify.replaceColor)("#ffffff", color, animation);
    } catch (e) {
        return animation;
    }
};
var LoadingBar = function(param) {
    var _param_color = param.color, color = _param_color === void 0 ? "green" : _param_color, _param_size = param.size, size = _param_size === void 0 ? "sm" : _param_size, className = param.className;
    var _useState = _slicedToArray((0, _react.useState)(20), 2), sizeValue = _useState[0], setSizeValue = _useState[1];
    (0, _react.useEffect)(function() {
        if (size === "sm") {
            setSizeValue(20);
        } else if (size === "md") {
            setSizeValue(40);
        } else if (size === "lg") {
            setSizeValue(48);
        } else {
            setSizeValue(size);
        }
    }, [
        size
    ]);
    var animationData = {};
    if (color === "green") {
        animationData = size === "lg" ? _loadingLogoAnimationGreen.default : _loadingBarAnimationGreen.default;
    } else if (color === "white") {
        animationData = size === "lg" ? _loadingLogoAnimationWhite.default : _loadingBarAnimationWhite.default;
    } else if (color && ColorExp.test(color)) {
        // FIXME: This will do string transformations on every render so it is not ideal
        // we should be able to do the transformations only once
        animationData = size === "lg" ? safeReplaceColor(color, _loadingLogoAnimationWhite.default) : safeReplaceColor(color, _loadingBarAnimationWhite.default);
    } else {
        animationData = size === "lg" ? _loadingLogoAnimationWhite.default : _loadingBarAnimationWhite.default;
    }
    var options = _objectSpreadProps(_objectSpread({}, DEFAULT_OPTIONS), {
        animationData: animationData
    });
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: className
    }, /*#__PURE__*/ _react.default.createElement(_reactLottie.default, {
        options: options,
        height: sizeValue,
        width: sizeValue
    }));
};

//# sourceMappingURL=LoadingBar.js.map